var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({attrs:{"loading":_vm.loadingStatus},on:{"click":_vm.handleClick}},'el-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }